import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

// Subliminal but hard — a voice for the powerless. Keep it loud, keep it moving.
const LINES = [
  "They can't speak. So we get loud.",
  "A voice for the voiceless.",
  "Bred to fight. Born to love.",
  "Nobody came for them. Be somebody.",
  "The powerless need the loud ones.",
  "Say their names. Wear their fight.",
  "Rescued — not returned.",
  "Where were you? Now you're here.",
  "Adopt the underdog. Become one.",
  "Every fit funds a second chance.",
  "Loud for the ones who can't be.",
];

export const MissionWhisper = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % LINES.length), 4200);
    return () => clearInterval(t);
  }, []);
  return (
    <Link to="/mission" className="block w-full bg-black border-b border-white/10 overflow-hidden group" data-testid="mission-whisper">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-9 flex items-center justify-center gap-2.5 text-center">
        <span className="inline-block h-1.5 w-1.5 rounded-full pulse-ring shrink-0" style={{ background: "#ccff00" }} />
        <AnimatePresence mode="wait">
          <motion.span key={i} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -6 }} transition={{ duration: 0.4 }}
            className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.22em] text-white/80 group-hover:text-white transition-colors" data-testid="mission-whisper-line">
            {LINES[i]}
          </motion.span>
        </AnimatePresence>
      </div>
    </Link>
  );
};

export default MissionWhisper;
